import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { Observable, Subject, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { ActivatedRoute} from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  category_id = new Subject();
  sub_category_id = new Subject();
  state_id = new Subject();
  city_id = new Subject();
  affiliation_id = new Subject();
  url:string = environment.url;

  constructor(private http: HttpClient, public route: ActivatedRoute) {
    this.route.queryParams
      .subscribe(params => {
        if(params.category_id){
          this.category_id.next(params.category_id)
        }
        if(params.sub_category_id){
          this.sub_category_id.next(params.sub_category_id)

        }
        if(params.affiliation_id){
          this.affiliation_id.next(params.affiliation_id)

        }
        if(params.state_id){
          this.state_id.next(params.state_id)
        }
        if(params.city_id){
          this.city_id.next(params.city_id)

        }
      }
    );
  }



  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;

    } else {
      // server-side error
      if(error.status === 404){
        errorMessage = `Page Not Found`;

      }else{
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;

      }
    }
    // window.alert(errorMessage);
    return throwError(errorMessage);
  }
  listSubCategory(){
    return this.http.get(`${this.url}home/sub-category/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  listUniqueCourse(){
    return this.http.get(`${this.url}home/unique-course/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }


  getHomePageFilter(category, subCategory, course){
    return this.http.get(
        `${this.url}course-filter/?main_category__slug=${category}&sub_category__slug=${subCategory}&unique_course__slug=${course}`
        ).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getAboutUs(){
    return this.http.get(`${this.url}about-us/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getTermAndCondition(){
    return this.http.get(`${this.url}term-and-condition/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getPolicy(){
    return this.http.get(`${this.url}privacy-policy/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  postContactForm(data){
    return this.http.post(`${this.url}website-contact-us-form/`, data).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getAffiliation(){
    return this.http.get(`${this.url}affilation/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getState(){
    return this.http.get(`${this.url}state/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getCity(){
    return this.http.get(`${this.url}city/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  getSubRegistrationType(){
    return this.http.get(`${this.url}sub-registration-type/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getRegistrationType(){
    return this.http.get(`${this.url}registration-type/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getCategory(){
      return this.http.get(`${this.url}home/category/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  getSubCategory(id){
    return this.http.get(`${this.url}home/sub-category/?category=${id}`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  getUniqueCourse(id){
    return this.http.get(`${this.url}home/unique-course/?SubCategories=${id}`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  getTopUniversity(){
    return this.http.get(`${this.url}home/top-university/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  getUniversityBySlug(slug){
    return this.http.get(`${this.url}universities/${slug}/`)
  }

  getAllUniversity(){
    return this.http.get(`${this.url}universities-page/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  postUniversityForm(data){
    return this.http.post(`${this.url}university-form-submit/`, data).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  getWebsiteDetail(){
    return this.http.get(`${this.url}website-detail/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getLatestNews(){
    return this.http.get(`${this.url}news-event/`).pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getLatestNewsById(slug){
    return this.http.get(`${this.url}news-event/${slug}`).pipe(
        retry(3),
      );
  }

}
